import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TabMessagePageRoutingModule } from './tab-message-routing.module';

import { TabMessagePage } from './tab-message.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TabMessagePageRoutingModule
  ],
  declarations: [TabMessagePage]
})
export class TabMessagePageModule {}
